import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { SMALL_TEXT_MAX_CHARACTERS } from 'constants/logic';
import { intlMessage } from 'constants/propTypes';
import { bem } from 'helpers/class-name';
import Title from 'features/App/Title';
import { Card, CardSection } from 'components/Card';
import { Form, Input } from 'components/HookForm';
import Message from 'components/Message';

import ServicesPicker from '../../Components/ServicesPicker/ServicesPickerContainer';
import { SingleDayExceptions } from '../../Components/SingleDayExceptions';
import { RecurringSchedule } from '../../Components/RecurringSchedule';
import FooterForm from '../../FooterForm/FooterFormContainer';
import { messages } from '../Resources.messages';
import './ResourceForm.scss';

const { block, element } = bem('resource-form');

function ResourceForm(props) {
  const navigate = useNavigate();

  const {
    defaultValues,
    deleteResource,
    handleCancel,
    handleSubmit,
    isLoaded,
    resourceName,
    servicesList,
    showDeleteButton,
    title,
    isLoading,
    venueId,
  } = props;

  const handleClickCancel = () => {
    navigate(-1);
  };

  if (!isLoaded) {
    return <Card loading />;
  }

  return (
    <Form
      id="resourceForm"
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      onReset={handleCancel}
      isLoading={!isLoaded}
      className={block()}>
      <Card flush className={element('card')}>
        <Message as={Title} message={title} values={{ resourceName }} />

        <CardSection>
          <Message className={element('label')} as="p" message={messages.form.labelInfo} />
          <div data-cypress="resource-name-input">
            <Input
              name="name"
              required
              maxLength={SMALL_TEXT_MAX_CHARACTERS}
              placeholder={messages.form.namePlaceholder}
              label={messages.form.name}
            />
          </div>

          <hr className="mv+" />
          <RecurringSchedule name="recurrence" />
          <hr className="mv+" />
          <SingleDayExceptions name="singleDayExceptions" venueId={venueId} />
          <hr className="mv+" />
          <ServicesPicker name="serviceIds" servicesList={servicesList} description={messages.form.serviceHint} />
        </CardSection>
        <FooterForm
          deleteMessage={messages.details.deleteResource}
          formName="resourceForm"
          visible
          submitting={isLoading}
          showDelete={showDeleteButton}
          onClickCancel={handleClickCancel}
          onClickDelete={deleteResource}
        />
      </Card>
    </Form>
  );
}

ResourceForm.propTypes = {
  defaultValues: PropTypes.shape({
    name: PropTypes.string,
    recurrence: PropTypes.arrayOf(PropTypes.shape({})),
    serviceIds: PropTypes.arrayOf(PropTypes.number),
    singleDayExceptions: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  deleteResource: PropTypes.func,
  handleCancel: PropTypes.func,
  handleSubmit: PropTypes.func,
  isLoaded: PropTypes.bool,
  isLoading: PropTypes.bool,
  resourceName: PropTypes.string,
  servicesList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      duration: PropTypes.string,
    })
  ),
  showDeleteButton: PropTypes.bool,
  title: intlMessage,
  venueId: PropTypes.number,
};

export default ResourceForm;
